import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postMatchmakerRecommendation,
  type PostMatchmakerRecommendationParams,
  type PostMatchmakerRecommendationResponse,
} from '@services/MatchmakerService';

export type UsePostMatchmakerRecommendationParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostMatchmakerRecommendationResponse,
    unknown,
    string,
    PostMatchmakerRecommendationParams,
    PostMatchmakerRecommendationResponse
  >;
};

export const postMatchmakerRecommendationMutationKey =
  'post-matchmaker-recommendation';

export const usePostMatchmakerRecommendation = ({
  mutationOptions,
}: UsePostMatchmakerRecommendationParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostMatchmakerRecommendationResponse,
    unknown,
    string,
    PostMatchmakerRecommendationParams
  >(
    postMatchmakerRecommendationMutationKey,
    (_url, { arg }) => postMatchmakerRecommendation(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
